import { Box } from "@mui/material";
import { useGetNotification } from "../../../../logic/useApiQuery";
import { AccountVerificationForm } from "./AccountVerificationForm";
import { AccountVerificationTaskStatusIndicator } from "./AccountVerificationTaskStatusIndicator";
import { PlaidComponent } from "./PlaidComponent";

export function AccountVerificationTask() {

  const { data: notification } = useGetNotification()

  return (
    <AccountVerificationTaskStatusIndicator>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {!notification?.IsPlaidOffered && <AccountVerificationForm />}
        {notification?.IsPlaidOffered && <PlaidComponent />}
      </Box>
    </AccountVerificationTaskStatusIndicator>
  )
}
